import { DeliveryModel } from '@audibene/ta.utils-opportunity'
import Joi from 'joi'
import { Country, TechSetupFailureReason } from '../../../../constants'
import { AppointmentCancellationFormData } from '../../../../types'
import { getPrimaryCancellationReasons, getPrimaryCancellationReasonDisplayText, PrimaryAppointmentCancellationReason } from '../utils'

const string = Joi.string()
const nullableString = string.allow(null, '')

function validationSchema(country: Country, deliveryModel?: DeliveryModel): Joi.ObjectSchema<AppointmentCancellationFormData> {
  const validReasons = getPrimaryCancellationReasons(country, deliveryModel)
  const displayText = getPrimaryCancellationReasonDisplayText(country, deliveryModel)
  const reason = Joi.string().valid(...validReasons)
  const techSetupFailReason = Joi.string().valid(...Object.values(TechSetupFailureReason))

  if (country === Country.DE) {
    return Joi.object<AppointmentCancellationFormData>({
      description: nullableString.optional(),
      reason: reason.required().messages({
        'any.only': 'Required',
      }),
      techSetupFailReason: nullableString.optional(),
    }).required()
  }

  const otherDisplayText = displayText[PrimaryAppointmentCancellationReason.OTHER]

  const description = Joi.any().when('reason', {
    is: PrimaryAppointmentCancellationReason.OTHER,
    then: string.required().messages({
      'string.empty': `Required when the reason for canceling is "${otherDisplayText}"`,
    }),
    otherwise: nullableString.optional(),
  })

  const techSetupFailReasonConditional = (validReasons as readonly string[]).includes(
    PrimaryAppointmentCancellationReason.TECH_SETUP_FAILED
  )
    ? Joi.any().when('reason', {
        is: PrimaryAppointmentCancellationReason.TECH_SETUP_FAILED,
        then: techSetupFailReason.required().messages({
          'string.empty': `Required when the reason for canceling is "${
            displayText[PrimaryAppointmentCancellationReason.TECH_SETUP_FAILED]
          }"`,
          'any.only': 'Required',
        }),
        otherwise: nullableString.optional(),
      })
    : nullableString.optional()

  return Joi.object<AppointmentCancellationFormData>({
    description,
    reason: reason.required().messages({
      'any.only': 'Required',
    }),
    techSetupFailReason: techSetupFailReasonConditional,
  }).required()
}

export { validationSchema }
